/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
/**
 * @deprecated Use icons from `@chilipiper/icons/figma-generated/src/icon` or
 *   `@chilipiper/icons/figma-generated/src/logo` instead
 */
export const SvgCrossTooltip = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={10} height={10} viewBox='0 0 10 10' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.4543 0.544824C9.96198 1.05251 9.96198 1.87562 9.4543 2.3833L6.838 4.9996L9.45432 7.61591C9.962 8.12359 9.962 8.9467 9.45432 9.45439C8.94664 9.96207 8.12352 9.96207 7.61584 9.45439L4.99953 6.83807L2.3833 9.4543C1.87562 9.96198 1.05251 9.96198 0.544824 9.4543C0.0371421 8.94662 0.0371421 8.1235 0.544824 7.61582L3.16105 4.9996L0.544841 2.38339C0.0371591 1.87571 0.0371591 1.05259 0.544841 0.54491C1.05252 0.0372284 1.87564 0.0372284 2.38332 0.54491L4.99953 3.16112L7.61582 0.544824C8.1235 0.0371421 8.94662 0.0371421 9.4543 0.544824Z'
    />
  </svg>
)
export default SvgCrossTooltip
